/*------------------------------------------------------------------------------------------
* © 2020 KPMG LLP, a Delaware limited liability partnership and 
* a member firm of the KPMG global organization of independent member firms 
* affiliated with KPMG International Limited, a private English company limited by guarantee. 
* All rights reserved.
*-----------------------------------------------------------------------------------------*/
import { Injectable } from '@angular/core';
import { of, Observable } from 'rxjs';
import { Client, Industry, Company, Acquisitions, IntangibleAssetCategory } from '../../models/client.model';
import { EnvSettingsService } from 'src/app/core/services/env-settings.service';
import { HttpClient } from '@angular/common/http';
import { IndustrySets } from '../../models/admin-mapping.model';

@Injectable({
  providedIn: 'root'
})
export class ClientService {

  private _clientApiRoute='/api/V1/Client';
  private _industryApiRoute='/api/V1/Industry';
  private _commonApiRoute = '/api/V1/Common';
  private _evsAdminRoute = '/api/V1/EVSAdminMapping';
  constructor(private _envSettings: EnvSettingsService,private _http: HttpClient) { }

  get clientServiceUrl(){
    return this._envSettings.getApiUrl() + this._clientApiRoute;
  }

  get industryServiceUrl(){
    return this._envSettings.getApiUrl() + this._industryApiRoute;
  }
  get commonServiceUrl() {
    return this._envSettings.getApiUrl() + this._commonApiRoute;
  }
  get industrySetServiceUrl() {
    return this._envSettings.getApiUrl() + this._evsAdminRoute;
  }

  searchClients(term: string): Observable<Array<Client>> {
    return this._http.get<Array<Client>>(this.clientServiceUrl + '/SearchClients/' + term);
  }
  
  addClient(client: Client): Observable<Client> {
    const apipath = this.clientServiceUrl + '/AddClient';
    return this._http.post<Client>(apipath, client);
  }

  searchIndustries(term: string): Observable<Array<Industry>> {
    return this._http.get<Array<Industry>>(this.industryServiceUrl + '/SearchIndustries/' + term);
  }

  getCompanyByIndustry(sic: number): Observable<Array<Company>> {
    return this._http.get<Array<Company>>(this.industryServiceUrl + '/GetCompanyByIndustry?sic=' + sic);
  }

  getCompanies(): Observable<Array<Company>> {
    return this._http.get<Array<Company>>(this.industryServiceUrl + '/GetCompanies');
  }

  getIndustries(): Observable<Array<Industry>> {
    return this._http.get<Array<Industry>>(this.industryServiceUrl + '/GetIndustries');
  }
  getAcquisitions(): Observable<Array<Acquisitions>> {
    return this._http.get<Array<Acquisitions>>(this.industryServiceUrl + '/GetAcquisitions');
  }
  getValidatedCompanies(): Observable<Array<Company>> {
    return this._http.get<Array<Company>>(this.industryServiceUrl + '/GetvalidatedCompanies');
  }

  getIntangibleAssetCatNames(){
    return this._http.get<Array<IntangibleAssetCategory>>(this.commonServiceUrl + '/GetIntangibleAssetCatNames');
  }
  
  getIndustrySets(): Observable<Array<IndustrySets>> {
    return this._http.get<Array<IndustrySets>>(this.industrySetServiceUrl + '/GetIndustrySets');
  }
}
